import { TreeNode, TreeNodeOrNodeSlug } from 'react-common'
import { CustomTreeNode } from '@/store/slices/layoutSlice'

type Item = Omit<CustomTreeNode, keyof TreeNodeOrNodeSlug> & TreeNode & Required<Pick<TreeNode, 'icon_id'>>

export const isValidSideBarItem = (item: CustomTreeNode): item is Item => {
  return typeof item !== 'string' && Boolean(item.icon_id)
}
